export const removeCommentsFromCss = (css: string) => {
  return css.replace(/\/\*[\s\S]*?\*\//g, '');
};
